// @flow
import { system, type Config } from 'styled-system';
import type { TextDecoration } from '@rover/design-system/style-dictionary/build/es6/theme';
import { createTransformWithDefault } from './transforms';

export type TextDecorationProps = {|
  textDecoration?: TextDecoration,
|};

const config: Config<TextDecorationProps> = {
  textDecoration: {
    property: 'textDecoration',
    scale: 'textDecoration',
    transform: createTransformWithDefault('none'),
  },
};

export default system<TextDecorationProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/textDecoration.js